/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostAttestationV3Resp
 */
export interface PostAttestationV3Resp {
    /**
     * 
     * @type {string}
     * @memberof PostAttestationV3Resp
     */
    token?: string;
}

/**
 * Check if a given object implements the PostAttestationV3Resp interface.
 */
export function instanceOfPostAttestationV3Resp(value: object): value is PostAttestationV3Resp {
    return true;
}

export function PostAttestationV3RespFromJSON(json: any): PostAttestationV3Resp {
    return PostAttestationV3RespFromJSONTyped(json, false);
}

export function PostAttestationV3RespFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAttestationV3Resp {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
    };
}

export function PostAttestationV3RespToJSON(json: any): PostAttestationV3Resp {
    return PostAttestationV3RespToJSONTyped(json, false);
}

export function PostAttestationV3RespToJSONTyped(value?: PostAttestationV3Resp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

